import { SxProps, Theme } from '@mui/material';

export const commonGridStyles: SxProps<Theme> = {
  border: 'none',
  minHeight: 200,
  color: 'var(--text-primary)',
  '& .MuiDataGrid-main': {
    borderRadius: '8px 8px 0 0',
    backgroundColor: 'var(--bg-panel)',
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: 'var(--bg-header-sub)',
    color: 'var(--text-secondary)',
    fontSize: '0.85rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: '1px solid var(--border-color)',
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      justifyContent: 'center',
    },
  },
  '& .MuiDataGrid-cell': {
    borderBottom: '1px solid rgba(46, 61, 77, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.03)',
    cursor: 'pointer',
  },
  '& .MuiDataGrid-virtualScroller': {
    // minHeight removed to prevent clipping of the last rows
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none',
  },
};
